import { createContext, useContext, useRef, useState } from "react";

const AlertContext = createContext(null);

export function AlertProvider({ children }) {
  const [alert, setAlert] = useState(null);
  const confirmResolver = useRef(null);

  const showAlert = ({ title = "Notice", message, type = "info" }) => {
    setAlert({ title, message, type, mode: "alert" });
  };

  const showConfirm = ({ title = "Are you sure?", message, type = "error" }) => {
    setAlert({ title, message, type, mode: "confirm" });

    return new Promise((resolve) => {
      confirmResolver.current = resolve;
    });
  };

  const closeAlert = () => {
    setAlert(null);
    confirmResolver.current = null;
  };

  const handleConfirm = () => {
    confirmResolver.current?.(true);
    closeAlert();
  };

  const handleCancel = () => {
    confirmResolver.current?.(false);
    closeAlert();
  };

  const icon =
    alert?.type === "success"
      ? "check_circle"
      : alert?.type === "error"
        ? "error"
        : "info";

  const accentColor =
    alert?.type === "success"
      ? "#2d7a4f"
      : alert?.type === "error"
        ? "#ba1a1a"
        : "#0a0c12";

  return (
    <AlertContext.Provider value={{ showAlert, showConfirm }}>
      {children}

      {alert && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.35)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 420,
              background: "#fff",
              borderRadius: 16,
              border: "1px solid #c4c7c7",
              boxShadow: "0 24px 80px rgba(0,0,0,0.22)",
              padding: 28,
            }}
          >
            <div style={{ marginBottom: 18 }}>
              <span className="material-symbols-outlined" style={{ fontSize: 40, color: accentColor }}>
                {icon}
              </span>
            </div>

            <h2 style={{ fontFamily: "Geist, sans-serif", fontSize: 22, color: "#0a0c12", margin: "0 0 8px" }}>
              {alert.title}
            </h2>

            <p style={{ color: "#5c5f60", fontSize: 15, lineHeight: 1.6, whiteSpace: "pre-line" }}>
              {alert.message}
            </p>

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
              {alert.mode === "confirm" && (
                <button onClick={handleCancel} style={buttonSecondary}>
                  No
                </button>
              )}

              <button onClick={alert.mode === "confirm" ? handleConfirm : closeAlert} style={buttonPrimary}>
                {alert.mode === "confirm" ? "Yes" : "OK"}
              </button>
            </div>
          </div>
        </div>
      )}
    </AlertContext.Provider>
  );
}

const buttonPrimary = {
  background: "#000",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  padding: "11px 22px",
  fontFamily: "Geist, sans-serif",
  fontSize: 13,
  fontWeight: 600,
  cursor: "pointer",
};

const buttonSecondary = {
  background: "#e6eff8",
  color: "#000",
  border: "1px solid #c4c7c7",
  borderRadius: 8,
  padding: "11px 22px",
  fontFamily: "Geist, sans-serif",
  fontSize: 13,
  fontWeight: 600,
  cursor: "pointer",
};

export function useAppAlert() {
  return useContext(AlertContext);
}